import React from "react";
import "./style.css";
import Logo from "../../assets/images/logo.png";
import ApparindoLogo from "../../assets/images/apparindo.png";
import OjkLogo from "../../assets/images/ojk.png";
import WhatsappLogo from "../../assets/images/whatsapp-white.png";
import { Col, Row } from "react-bootstrap";

const credentials = [
  {
    name: "Apparindo",
    src: ApparindoLogo,
    text: "247-2018/APPARINDO/2025",
  },
  {
    name: "Ojk",
    src: OjkLogo,
    text: "KEP-38/NB.1/2018",
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <Row>
        <Col lg={4} xs={12}>
          <div>
            <span>Powered By</span>
            <div className="logo-wp">
              <img src={Logo} height="60px" alt="logo" />
            </div>
            <p>
              <strong className="title">
                PT Pialang Asuransi Provis Mitra Sinergi
              </strong>
            </p>
            <p>
              Dipo Business Center, Rukan B-02,
              <br />
              JI. Gatot Subroto No.Kav 50-52,
              <br />
              Kelurahan Petamburan, Kecamatan Tanah Abang,
              <br />
              Jakarta Pusat, Jakarta, 10260
              <br />
              Indonesia
            </p>
          </div>
        </Col>
        <Col
          lg={8}
          xs={12}
          className="d-flex flex-column justify-content-center"
        >
          <p>
            PT Pialang Asuransi Provis Mitra Sinergi (Polismall) terdaftar dan
            diawasi oleh Otoritas Jasa Keuangan.
          </p>

          <div className="d-flex flex-column flex-lg-row gap-4 w-100 align-items-start align-items-lg-center">
            {credentials.map((c) => (
              <div
                key={c.name}
                className="d-flex align-items-center"
                style={{
                  gap: "0px",
                  maxWidth: "100%",
                }}
              >
                {/* Logo */}
                <div
                  style={{
                    width: 140,
                    height: 75,
                    display: "flex",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={c.src}
                    alt={`${c.name} logo`}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>

                <div>
                  <p
                    className="fw-semibold mb-0"
                    style={{
                      fontSize: "14px",
                      whiteSpace: "normal",
                    }}
                  >
                    {c.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>

      <hr />
      <div
        className="footer-second-item"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="copyright">
          Hak Cipta &copy; {new Date().getFullYear()} Polismall - PT Pialang
          Asuransi Provis Mitra Sinergi
        </div>

        <div className="menu">
          <ul>
            <li>
              <a
                href="https://www.polismall.id/"
                target="_blank"
                rel="noreferrer"
              >
                Tentang Kami
              </a>
            </li>
            <li>
              <a
                href="https://polismall.id/terms"
                target="_blank"
                rel="noreferrer"
              >
                Ketentuan Layanan
              </a>
            </li>
            <li>
              <a
                href="https://polismall.id/kebijakan-privasi"
                target="_blank"
                rel="noreferrer"
              >
                Kebijakan Privasi
              </a>
            </li>
          </ul>
        </div>
      </div>

      <a
        href="https://api.whatsapp.com/send/?phone=6285157882495&text=Hi+Provis+support%2C+saya+butuh+bantuan+terkait+ketidakansesuaian+antara+sertifikat+yang+saya+terima+dengan+qr+code+yang+saya+scan&type=phone_number&app_absent=0"
        target="_blank"
        rel="noreferrer"
      >
        <div className="whatsapp">
          <img src={WhatsappLogo} alt="wa" />
        </div>
      </a>
    </footer>
  );
}
